export default __webpack_public_path__ + "static/media/a023-example2.95e94120.png";